import React, { useState } from 'react';
import { TIconColor } from '@/components/Icons/iconVariant';
import { IconProps } from '@/components/Icons/types/IconInterface';
import { ChevronDownIcon } from '@/components/Icons';
import SideNavSubMenu, { SideNavSubMenuItem } from './SideNavSubMenu';
import { colorVariant } from './colorVariant';
import cn from '@/utils/cn';

interface SideNavMenuItemProps {
  icon: React.ComponentType<IconProps & { color?: TIconColor }>;
  label: string;
  onClick?: () => void;
  subItems?: SideNavSubMenuItem[];
  isExpanded?: boolean;
  onToggle?: () => void;
  isActive?: boolean;
  loading?: boolean;
  headerAction?: React.ReactNode;
  hideChevron?: boolean;
  className?: string;
}

const ITEM = cn(
  colorVariant({ text: 'white' }),
  'nav-item-hover group flex items-center gap-3 px-2 py-1.5 text-xs font-medium transition-colors w-full rounded-lg'
);

const ICON = 'transition-colors';

const ICON_WRAPPER = 'flex items-center gap-3';

const LABEL = 'transition-opacity duration-200';

const CHEVRON = 'flex-shrink-0 transition-transform';

const SideNavMenuItem = ({
  icon: Icon,
  label,
  onClick,
  subItems,
  isExpanded,
  onToggle,
  isActive,
  loading,
  headerAction,
  hideChevron,
  className
}: SideNavMenuItemProps) => {
  const [localExpanded, setLocalExpanded] = useState(false);

  const controlled = isExpanded !== undefined;
  const expanded = controlled ? isExpanded : localExpanded;
  const hasSubmenu = subItems && subItems.length > 0;

  const handleClick = () => {
    if (hasSubmenu || loading) {
      if (controlled) onToggle?.();
      else setLocalExpanded((prev) => !prev);
    }
    onClick?.();
  };

  return (
    <>
      <div className={cn(ITEM, isActive && 'text-emerge-teal', 'justify-between', className)}>
        <button
          type="button"
          onClick={handleClick}
          className="flex flex-1 min-w-0 items-center justify-between bg-transparent">
          <div className={ICON_WRAPPER}>
            <Icon size="sm" color={isActive ? 'green' : 'white'} className={ICON} />
            <span className={LABEL}>{label}</span>
          </div>
          {hasSubmenu && !hideChevron && (
            <ChevronDownIcon size="xxs" className={cn(CHEVRON, expanded && 'rotate-180')} />
          )}
        </button>
        {headerAction}
      </div>
      {(hasSubmenu || loading) && expanded && (
        <SideNavSubMenu subItems={subItems ?? []} loading={loading} />
      )}
    </>
  );
};

export default SideNavMenuItem;
